// src/ui/components/LoadingSpinner.tsx
import { h } from "preact";

export function LoadingSpinner() {
    return (
        <div role="status" aria-label="Loading" className="loading-spinner">
            <div className="spinner"></div>
            <span className="sr-only">Loading...</span>
        </div>
    );
}
